import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Button, Card, Form } from 'react-bootstrap';
import { fetchSucursales } from '../../controller/sucursalController'; // Asegúrate de que la ruta sea correcta

import { generarReporteGeneral } from '../../utils/Reports/GenerateGeneralReport';
import { fetchAsistenciasPorSucursal } from '../../controller/attendanceController';
import { parseAttendanceResponse } from '../../utils/ParseAttendance/ParseAttendanceResponse';
import { generarReporteColectivo } from '../../utils/Reports/GenerateColectivoRepot';
import { parseAttendanceTardanzaResponse } from '../../utils/ParseAttendance/ParseAttendanceTardanzaResponse';
import { generarReporteTardanza } from '../../utils/Reports/GenerateTardanzaReport';
import { generarReporteColectivoTardanza } from '../../utils/Reports/GenerateColectivoTardanzaReport';

function ReportView() {
  const [sucursales, setSucursales] = useState([]);
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState('');
  const [fechaInicio, setFechaInicio] = useState('');
  const [fechaFin, setFechaFin] = useState('');
  const [tipoReporte, setTipoReporte] = useState('general'); // 'general', 'tardanza', 'colectivo'

  useEffect(() => {
    const cargarSucursales = async () => {
      try {
        const data = await fetchSucursales();
        setSucursales(data);
      } catch (error) {
        console.error('Error al cargar sucursales:', error);
      }
    };
    cargarSucursales();
  }, []);




  const handleGenerarReporte = async () => {
    if (!sucursalSeleccionada || !fechaInicio || !fechaFin) {
      alert('Por favor, selecciona una sucursal y el rango de fechas.');
      return;
    }

    try {
     const rawData = await fetchAsistenciasPorSucursal(sucursalSeleccionada, fechaInicio, fechaFin);
    

      if (tipoReporte === 'general') {
          const parsedData =await parseAttendanceResponse(rawData);
        generarReporteGeneral(parsedData);
      } else if (tipoReporte === 'tardanza') {
        const parsedData = await parseAttendanceTardanzaResponse(rawData)
     
        generarReporteTardanza(parsedData);
      } else if (tipoReporte === 'colectivo') {
          const parsedData =await parseAttendanceResponse(rawData);
        
        generarReporteColectivo(parsedData);
      }
      else if (tipoReporte === 'tardanza colectivo') {
          const parsedData = await parseAttendanceTardanzaResponse(rawData);
        
        generarReporteColectivoTardanza(parsedData);
      }

    } catch (error) {
      console.error(error);
      alert('Hubo un error al generar el reporte. Intenta de nuevo.');
    }
  };


  return (
    <Container className="mt-5">
      <Row className="mb-4">
        <Col>
          <h1>Reportes</h1>
        </Col>
      </Row>

      <Card className="p-4">
        <h4>Reporte {tipoReporte}</h4>
        <p>Genera un informe completo de todas las Horas registradas.</p>

        <Form.Group className="mb-3">
          <Form.Label>Sucursal</Form.Label>
          <Form.Select
            value={sucursalSeleccionada}
            onChange={(e) => setSucursalSeleccionada(e.target.value)}
          >
            <option value="">Selecciona una sucursal</option>
            {sucursales.map((sucursal) => (
              <option key={sucursal.id} value={sucursal.id}>
                {sucursal.name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Fecha Inicio</Form.Label>
          <Form.Control
            type="date"
            value={fechaInicio}
            onChange={(e) => setFechaInicio(e.target.value)}
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Fecha Fin</Form.Label>
          <Form.Control
            type="date"
            value={fechaFin}
            onChange={(e) => setFechaFin(e.target.value)}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Tipo de Reporte</Form.Label>
          <Form.Select value={tipoReporte} onChange={(e) => setTipoReporte(e.target.value)}>
            <option value="general">General</option>
              <option value="colectivo">General Colectivo</option>
            <option value="tardanza">Tardanzas</option>
                <option value="tardanza colectivo">Tardanza Colectivo</option>
        
          </Form.Select>
        </Form.Group>


        <Button variant="primary" onClick={handleGenerarReporte}>
          Generar Reporte
        </Button>
      </Card>
    </Container>
  );
}

export default ReportView;
